module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio59-588f556bef4cf4113fa356a571ea2979.m4a";